import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { TicketStatus } from '../enum/ticket-status';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { TicketsService } from '../services/tickets.service';
import { StorageService } from '../services/storage.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class ReceivedTicketGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService,
    private ticketsService: TicketsService,
    private storageService: StorageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    let ticketId = route.paramMap.get('ticketId');
    if (ticketId) {
      ticketId = this.getAndSetTicketId(ticketId);
      if (!this.userService.user) {
        return this.router.parseUrl('/auth');
      }
      return this.fetchUserTicket(ticketId);
    }
    return false;
  }

  private fetchUserTicket(ticketId: string): Observable<boolean | UrlTree> {
    return this.ticketsService.getUserReceivedTicketById(ticketId).pipe(
      catchError(() => {
        this.storageService.removeFromStorage('ticketId');
        this.router.parseUrl('/');
        return of(null);
      }),
      map((ticket) => {
        if (ticket?.status === TicketStatus.pending) {
          return true;
        }
        this.storageService.removeFromStorage('ticketId');
        return this.router.parseUrl('/');
      })
    );
  }

  private getAndSetTicketId(ticketId: string): string {
    const currentTicketId =
      this.storageService.getFromStorage<string>('ticketId');
    if (!currentTicketId || currentTicketId !== ticketId) {
      this.storageService.saveToStorage<string>(
        'ticketId',
        ticketId,
        localStorage
      );
      return ticketId;
    }
    return currentTicketId;
  }
}
